/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Box as MuiBox, Link, styled } from "@mui/material";
import React from "react";

import Typography from "../../../components/Typography";

const Box = styled(MuiBox)({
  display: "flex",
  gap: "16px",
});

interface TitleWithLinkProps {
  title: string;
  linkTitle: string;
  linkTo: () => void;
  testId?: string;
}
export const TitleWithLink = ({ title, linkTitle, linkTo, testId }: TitleWithLinkProps) => {
  return (
    <Box>
      <Typography variant="h4" component="h3" color="primary500">
        {title}
      </Typography>
      <Link onClick={linkTo} variant="body2" data-testid={testId}>
        {linkTitle}
      </Link>
    </Box>
  );
};
